/**
 * SEO 工具函数
 * 用于动态更新页面的 title、keywords 和 description
 */

/**
 * 更新页面的 SEO 信息
 * @param {Object} seoInfo - SEO 信息对象
 * @param {string} seoInfo.title - 页面标题
 * @param {string} seoInfo.keywords - 页面关键词
 * @param {string} seoInfo.description - 页面描述
 */
export function updateSEO({ title, keywords, description }) {
  // 更新 title
  if (title) {
    document.title = title
  }

  // 更新或创建 keywords meta 标签
  let keywordsMeta = document.querySelector('meta[name="keywords"]')
  if (!keywordsMeta) {
    keywordsMeta = document.createElement('meta')
    keywordsMeta.setAttribute('name', 'keywords')
    document.head.appendChild(keywordsMeta)
  }
  if (keywords) {
    keywordsMeta.setAttribute('content', keywords)
  }

  // 更新或创建 description meta 标签
  let descriptionMeta = document.querySelector('meta[name="description"]')
  if (!descriptionMeta) {
    descriptionMeta = document.createElement('meta')
    descriptionMeta.setAttribute('name', 'description')
    document.head.appendChild(descriptionMeta)
  }
  if (description) {
    descriptionMeta.setAttribute('content', description)
  }
}

/**
 * 获取默认 SEO 配置
 */
export function getDefaultSEO() {
  return {
    title: '明晟环保科技有限公司 | 氨法脱硫创领者_超低排放_烟气脱白_烟气脱硫脱硝工程公司',
    keywords: '脱硫,脱硝,脱硫脱硝,氨法脱硫,超低排放,烟气脱白',
    description: '拥有国内氨法脱硫最先进核心工艺，烟气脱硫脱硝工程EPC总包，烟气脱白工程公司知名企业！'
  }
}


